import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const ValidationSelect = ({ input, label, options, disabled, meta: { touched, error } }) => (
  <div className={`form-group ${error && touched ? 'has-error' : ''}`}>
    <label htmlFor={input.name} className="col-sm-2">
      {label}
    </label>
    <div className="col-sm-10">
      <select {...input} disabled={disabled} className="form-control">
        {_.map(options, (o, idx) => {
          if (_.isObject(o)) {
            return (
              <option value={o._id || o.value} key={idx}>
                {o._id || o.label}
              </option>
            );
          } else {
            return (
              <option value={o} key={idx}>
                {o}
              </option>
            );
          }
        })}
      </select>
      {error && touched && (
        <span className="glyphicon glyphicon-remove form-control-feedback"></span>
      )}
      {error && touched && (
        <div className="text-danger">
          <strong>{error}</strong>
        </div>
      )}
    </div>
  </div>
);

ValidationSelect.propTypes = {
  input: PropTypes.object,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  options: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
};

ValidationSelect.defaultProps = {
  input: {},
  disabled: false,
};

export default ValidationSelect;
